export default __webpack_public_path__ + "static/media/health.6ec87c62.svg";